import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { PowerOutagesPage, PowerOutagesPageProps } from "./PowerOutagesPage";

export const EMPTY_PAGE_CONTENT: PowerOutagesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/outages-faults/power-outages";

export const PowerOutagesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<PowerOutagesPageProps>("power_outages", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <PowerOutagesPage {...routeProps} {...content} />;
};
